import request from '../utils/request';
import type { ApiResponse } from '@/types';

/** 登录相关 API */
export const authAPI = {
  /** 发送短信验证码 */
  sendCode: (phone: string): Promise<ApiResponse<null>> =>
    request.post('/auth/send-code', { phone }) as Promise<ApiResponse<null>>,

  /** 手机号+验证码登录 */
  login: (phone: string, code: string): Promise<ApiResponse<{ token: string }>> =>
    request.post('/auth/login', { phone, code }) as Promise<ApiResponse<{ token: string }>>,

  /** 退出登录 */
  logout: (): Promise<ApiResponse<null>> =>
    request.post('/auth/logout') as Promise<ApiResponse<null>>,
};

/** 文章管理 API */
export const articleAdminAPI = {
  /** 创建文章 */
  create: (data: {
    title: string;
    summary: string;
    content: string;
    status: string;
    tags?: string[];
  }): Promise<ApiResponse<{ id: number }>> =>
    request.post('/admin/articles', data) as Promise<ApiResponse<{ id: number }>>,

  /** 更新文章 */
  update: (id: number, data: Record<string, unknown>): Promise<ApiResponse<null>> =>
    request.put(`/admin/articles/${id}`, data) as Promise<ApiResponse<null>>,

  /** 删除文章 */
  delete: (id: number): Promise<ApiResponse<null>> =>
    request.delete(`/admin/articles/${id}`) as Promise<ApiResponse<null>>,
};

/** 标签管理 API */
export const tagAPI = {
  /** 获取标签列表 */
  getList: (): Promise<ApiResponse<TagRecord[]>> =>
    request.get('/admin/tags') as Promise<ApiResponse<TagRecord[]>>,

  /** 创建标签 */
  create: (data: { value: string; label: string }): Promise<ApiResponse<TagRecord>> =>
    request.post('/admin/tags', data) as Promise<ApiResponse<TagRecord>>,

  /** 删除标签 */
  delete: (id: number): Promise<ApiResponse<null>> =>
    request.delete(`/admin/tags/${id}`) as Promise<ApiResponse<null>>,
};

/** 标签记录类型 */
export interface TagRecord {
  id: number;
  value: string;
  label: string;
}
